// Вкладка «Основное»: поля карточки, разложенные по группам.
//
// ПОРЯДОК ПОЛЕЙ — НЕ ОФОРМЛЕНИЕ, А ИНСТРУМЕНТ. Владелец просил отдельно: заполнять сделку
// должно быть легко и понятно. Значит, поля идут в том порядке, в каком человек узнаёт
// ответы: сначала кто и о чём, потом деньги, потом сроки, потом условия и прочее. Порядок
// задан один раз в описании сущности (`specs/*.ts`), и здесь он только выполняется —
// сортировать поля тут нельзя, иначе описание перестанет быть правдой об экране.
//
// ГРУППА — ЭТО ОТВЕТ НА ВОПРОС, А НЕ ЯЩИК. У группы есть заголовок человеческими словами
// и, если нужно, подсказка на всю группу: «Курс фиксируется на дату документа» объяснять
// в каждом из трёх полей незачем.

import { Field } from './Field'
import type { ИсточникКарточек } from './source'
import type { КодВкладки, ОписаниеКарточки, Сущность } from './types'
import type { Форма } from './useCardForm'

interface Props {
  описание: ОписаниеКарточки
  форма: Форма
  источник: ИсточникКарточек
  безПравки?: boolean
  путьСущности?: (с: Сущность, id: string) => string
  /**
   * Какой вкладке принадлежат группы. По умолчанию «основное».
   *
   * Группа сама говорит, где ей место: роли и договор относятся к связям, вложения —
   * к документам. Рисовать поля только на «Основном» значило бы, что часть полей
   * описана, но недоступна — а это худший вид пропажи: молчаливый.
   */
  вкладка?: КодВкладки
}

export function MainTab({
  описание, форма, источник, безПравки, путьСущности, вкладка = 'основное',
}: Props) {
  const группы = описание.группы.filter((г) => (г.вкладка ?? 'основное') === вкладка)

  return (
    <>
      {группы.map((г) => {
        const поля = описание.поля.filter((п) => п.группа === г.код)
        if (!поля.length) return null
        return (
          <div className="card" key={г.код}>
            <h2>{г.заголовок}</h2>
            {г.подсказка && <div className="hint">{г.подсказка}</div>}
            <div className="card-fields">
              {поля.map((п) => (
                <Field
                  key={п.код}
                  поле={безПравки ? { ...п, толькоЧтение: true, почемуНельзяПравить:
                    'Карточка открыта только на чтение.' } : п}
                  все={форма.сПометкой}
                  onChange={форма.установить}
                  источник={источник}
                  ошибка={форма.ошибки[п.код]}
                  показатьОшибку={форма.тронутые.has(п.код)}
                  изменено={форма.изменённые.has(п.код)}
                  подставленоИз={форма.подставленные[п.код]}
                  путьСущности={путьСущности}
                />
              ))}
            </div>
          </div>
        )
      })}
    </>
  )
}
